import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { FAQ } from "@/components/features/faq";

import { useConfirmParams } from "./hooks";

export const FAQPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="FAQ" url={generatePath(PATHS.FAQ, { hotelID })}>
			<FAQ hotelID={hotelID} />
		</PageMeta>
	);
};
